module.exports = __webpack_public_path__ + "static/media/underage-logo.f3b1140a.svg";